import React, { useEffect } from 'react';
import { EImzaLoginRaporDogrulamaProps } from '.';
import { Box, Grid, TextField, Typography } from 'src/components';
import { translate } from 'src/i18n/tHelper';
import { FormikProps, useFormik } from 'formik';
import EImzaLoginSlice, { EImzaLoginAramaKriterleri } from 'src/store/slices/Auth/EImzaLoginSlice';
import { useAppDispatch, useAppSelector } from 'src/store';
import BaseComponent from 'src/core/base.component';
import SnackbarUtils from 'src/utils/SnackbarUtils';
import { useTranslation } from 'react-i18next';

let formik: FormikProps<EImzaLoginAramaKriterleri> = null;

export const eImzaLoginSearchHandlerClick = (e) => {
    formik.submitForm();
};

export const randomSayiUret = (min: number, max: number): number => {
    return Math.floor(Math.random() * (max - min)) + min;
}

export const rastgeleVeriUret = (): string => {
    let deger = "";
    let dizi = "ABCDEFGHIJKLMNOPRSTUVYZ0123456789"
    for (let i = 0; i < 6; i++) {
        deger = deger + dizi[randomSayiUret(0, 33)];
    }
    return deger;
};

const EImzaLoginRaporDogrulamaAramaKriterleri = (props: EImzaLoginRaporDogrulamaProps): JSX.Element => {
    const eImzaLoginState = useAppSelector(s => s.EImzaLoginState);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    formik = useFormik({
        enableReinitialize: true,
        initialValues: eImzaLoginState.aramaKriterleri,
        validateOnChange: false,
        onSubmit: (values) => {
            dispatch(EImzaLoginSlice.actions.setRastgeleDeger(rastgeleVeriUret()));
            if (values.dogrulamaKodu !== eImzaLoginState.rastgeleDeger) {
                dispatch(EImzaLoginSlice.actions.setKontrol(true));
                formik.setFieldValue("dogrulamaKodu", "");
                SnackbarUtils.warning(translate("pages|login", "Doğrulama kodunu kontrol edin"))
                return;
            }
            dispatch(EImzaLoginSlice.actions.setAramaKriterleri(values));
            dispatch(EImzaLoginSlice.actions.setKontrol(false));
        }
    });

    useEffect(() => {
        dispatch(EImzaLoginSlice.actions.setRastgeleDeger(rastgeleVeriUret()));
    }, [])

    return (
        <BaseComponent
            onAcceptHandle={eImzaLoginSearchHandlerClick}
        >
            <Grid container>
                <Grid item>
                    <Typography textAlign="center" variant="subtitle2" color="red">
                        {t("pages|login|eimzaRaporDogrulamaBelgeKoduIleYapabilirsiniz", "e-Imza ile onaylanmış raporlarınızın doğrulamasını raporunuzun alt kısmında bulunan belge kodu ile yapabilirsiniz.")}
                    </Typography>
                </Grid>
                <Grid item>
                    <TextField
                        label={translate("pages|login", "Belge Kodu")}
                        name="belgeKodu"
                        value={formik.values.belgeKodu}
                        onChange={formik.handleChange}
                        error={Boolean(formik.errors.belgeKodu)}
                        helperText={formik.errors.belgeKodu}
                    />
                </Grid>
                <Grid item md={4} lg={3} xl={2}>
                    <TextField
                        label={translate("pages|login", "Doğrulama Kodu")}
                        name="dogrulamaKodu"
                        value={formik.values.dogrulamaKodu}
                        onChange={formik.handleChange}
                        error={Boolean(formik.errors.dogrulamaKodu)}
                        helperText={formik.errors.dogrulamaKodu}
                    />
                </Grid>
                <Grid item md={4} lg={3} xl={2}>

                    <Box bgcolor="black" width="100%" height="100%" borderRadius={1}>
                        <Typography noWrap variant="h1" color="primary" textAlign="center" sx={{ userSelect: "none" }}>
                            {eImzaLoginState.rastgeleDeger}
                        </Typography>
                    </Box>

                </Grid>
            </Grid>
        </BaseComponent>
    )
}

export default EImzaLoginRaporDogrulamaAramaKriterleri;